import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../_providers/TranslationProvider.client'

const PageIndicator = styled.output`
  ${TypeStyle.css.bodyMicro};
  padding: ${o => o.theme.spacing(1, 3)};
  background: ${o => o.theme.color.badge.neutral.fill.on.background};
  font-weight: 600;
  line-height: 20px;
  border-radius: ${o => o.theme.borderRadius.sm};
`

export interface PaginationPageIndicatorProps {
  currentIndex: number
  totalCount: number
  className?: string
}

export const PaginationPageIndicator = ({
  currentIndex,
  totalCount,
  className,
}: PaginationPageIndicatorProps) => {
  const {
    pagination: { pageIndicator },
  } = useTranslation()

  const label = pageIndicator
    .replace('{{currentIndex}}', String(currentIndex))
    .replace('{{totalPages}}', String(totalCount))

  return (
    <PageIndicator
      className={className}
      aria-label={label}
      role='status'
      aria-atomic='true'
      aria-live='polite'
    >
      {currentIndex}/{totalCount}
    </PageIndicator>
  )
}
